// Copyright (C) Lembani Sakala - All rights reserved.
// Lembani Sakala.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.

import React from 'react';
import comp from '../../images/car-rental-close.png';

export const About = () => {
  return (
    <section className="about-section-clean position-relative py-5" style={{ background: 'linear-gradient(120deg, #f8fafc 60%, #e3e8ee 100%)', overflow: 'hidden' }}>
      <div style={{
        position: 'absolute',
        top: '-120px',
        left: '-180px',
        width: '400px',
        height: '400px',
        background: 'radial-gradient(circle, #0d6efd 0%, #fff0 80%)',
        zIndex: 0,
        opacity: 0.16,
        borderRadius: '50%',
        filter: 'blur(2.5px)'
      }} />
      <div className="container position-relative" style={{zIndex: 2}}>
        <div className="row align-items-center justify-content-center g-5">
          <div className="about-img col-12 col-md-5 mb-4 mb-md-0 d-flex justify-content-center">
            <img src={comp} className="img-fluid rounded-4 shadow-sm" alt="About City Drive" style={{maxHeight: 340, objectFit: 'cover'}} />
          </div>
          <div className="col-12 col-md-7">
            <h2 className="fw-bold display-5 mb-3 text-center text-md-start">About Us</h2>
            <p className="lead text-secondary mb-4 text-md-start">
              We believe in changing lives and moving society forward. City Drive is a mobility solutions company with a workforce passionate about innovation, integrity, and hard work. We deliver a unique customer experience through car rental, taxi, and courier/delivery services. With over 14 years of industry experience, we serve customers in Zambia, Namibia, Mozambique, and international visitors.
            </p>
            <div className="row g-4">
              <div className="col-12 col-md-6">
                <div className="p-4 bg-white rounded-4 shadow-sm h-100">
                  <h3 className="h5 fw-bold mb-2 text-danger">Our Mission</h3>
                  <p className="mb-0 text-secondary">To facilitate and enable the movement of people and goods in a cost-effective and reliable manner.</p>
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="p-4 bg-white rounded-4 shadow-sm h-100">
                  <h3 className="h5 fw-bold mb-2 text-primary">Our Vision</h3>
                  <p className="mb-0 text-secondary">To become the go-to platform for affordable and reliable mobility solutions in Zambia and Africa.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
